module.exports = __webpack_public_path__ + "static/media/student-photo-upload.9e5798ea.png";